import React from 'react';
import ReactDOM from "react-dom/client";
import '@/utils/localeSetup.ts'

import { KeycloakProvider } from '@/app/providers/KeycloakProvider';
import { FrontolCodeTrackerProvider } from './app/providers/FrontolCodeTrackerProvider';
import { RoleBasedRouter } from '@/app/RoleBasedRouter';

import './normolize.css'
import "./styles.scss";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <KeycloakProvider>
      <FrontolCodeTrackerProvider>
        <RoleBasedRouter />
      </FrontolCodeTrackerProvider>
    </KeycloakProvider>
  </React.StrictMode>,
);
